// @flow
import DiamondSpecTable from '@components/productDetail/DiamondSpecTable';

import LinkPopup from '@components/popups/Link';
import * as CutContent from '@components/popups/content/Cut';

const cuts = [
  {
    symbol: 'EX',
    title: 'Excellent',
    name: 'excellent',
    descriptions: [
      'This Excellent cut diamond is cut to near perfect proportions, which allows nearly all light to reflect, creating exceptional fire and brilliance.  '
    ]
  },
  {
    symbol: 'VG',
    title: 'Very Good',
    name: 'very good',
    descriptions: [
      'This Very Good cut diamond properly reflects most of the light that enters, appearing nearly identical to an EX cut for the untrained observer.  '
    ]
  },
  {
    symbol: 'G',
    title: 'Good',
    name: 'good',
    descriptions: [
      'This Good cut diamond reflects most of the light that enters, for an above average appearance. An excellent value compared to the higher cut grades.'
    ]
  },
  {
    symbol: 'F',
    title: 'Fair',
    name: 'fair',
    descriptions: [
      'This Fair cut diamond lacks the fire and brilliance of higher cuts, but may be an attractive choice for those prioritizing size over appearance.'
    ]
  }
];

const Popup = ({ children, className, style = {} }) => (
  <LinkPopup initialContent={CutContent} className={className} style={style}>
    {children}
  </LinkPopup>
);

class DiamondCutTable extends React.Component<{ cut: string }> {
  render() {
    return (
      <DiamondSpecTable
        index={cuts.findIndex(cut => cut.title === this.props.cut)}
        spec={'cut'}
        items={cuts}
        style={{ marginTop: '24px' }}
        Popup={Popup}
      />
    );
  }
}

export default DiamondCutTable;
